module.exports = __webpack_public_path__ + "static/media/icon2.5013b756.png";